import React,{useEffect, useState} from 'react';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import Card from '../Generic/Card';
import ManualControlConnector from './Connector/ManualControlConnector';
import InputBox from '../Generic/InputBox';
import Button from '../Generic/Button';
import { HomingService } from './Service/HomingService';
import { CollectorJoggingService,MixerJoggingService } from './Service/JoggingService';
import { GoalPositionService } from './Service/GoalPositionService';
import { errorNotification , successNotification } from '../Generic/Notifications';
import { beautifyKey } from '../util/util';
import ControlService from './Service/ControlService';
import close from '../Assets/Close.png';
import SuccessButton from '../Generic/SuccessButton';
import Dropdown from '../Generic/Dropdown';

const Page = styled.div`
   height:100%;
   width:100%;
   display:flex;
   flex-direction:column;
   align-items:center;
   padding:0 0 2rem 0;
   overflow-Y:auto
`;

const Header = styled.div`
display:flex;
font-size:${props => props.fontSize};
margin:${props => props.margin};
justify-content:center;
`;

const Container = styled.div`
height:max-content;
width:${props => props.width};
padding:${props => props.padding};
display:flex;
flex-direction:${props => props.flexDirection};
justify-content:${props => props.jContent};
flex-wrap:wrap;
align-items:center;
@media(min-width:1200px)
{
   width:${props => props.widthAfter1000};
}
@media(max-width:800px)
{
   width:${props => props.widthBefore800}
}
@media(max-width:550px)
{
   padding:${props => props.paddingAt550};
}
`;

const Div = styled.div`
background:${props => props.background};
color:${props => props.color};
display:flex;
flex-direction:${props => props.flexDirection};
flex-wrap:${props => props.flexWrap};
justify-content:${props => props.jContent};
align-items:${props => props.alignItem};
padding:${props => props.padding};
margin:${props => props.margin};
text-align:${props => props.txtAlign};
font-size:${props => props.fontSize };
width:${props => props.width};
`;

const Span = styled.span`
font-size:${props => props.fontSize};
font-weight:${props => props.fontWeight};
font-family:${props => props.fontFamily};
color:${props => props.color};
margin:${props => props.margin};
padding:${props => props.padding};
`;

const Background = styled.div`
position:fixed;
display:flex;
justify-content:center;
align-items:center;
background:rgba(0,0,0,0.3);
left:0;
top:0;
right:0;
bottom:0;
z-index:310;
`;

const Modal = styled.div`
display:flex;
flex-direction:column;
background:#ffffff;
height:max-content;
width:22rem;
border-radius:10px;
z-index:305;
overflow-X:hidden;
`;

Container.defaultProps = {
   padding:"2rem",
   jContent:"center",
   width:"100%"
}

Header.defaultProps = {
   fontSize:"2rem",
   margin:"2rem 0 0rem 0"
}

 const ManualControl = (props) => {

   const [page,setPage] = useState(1);
   const [tab,showTab] = useState(1);
   const [homed,setHoming] = useState(false);
   const [modal,showModal] = useState(false);
   const rotateDirect = [{head:"Clockwise",value:"clockwise"},{head:"Anti-Clockwise",value:"anti-clockwise"}];
   const [mixerPayload ,setMixerPayload] = useState({"rpm":null,"direction":null});

   function validate(action)
   {
      var flag = false;
      var error = "";

      //Numeric values only
      const regex = /[0-9]{1,20}/;

      //Get all the input fields from the container of the given action
      var inputs = document.querySelectorAll("#" + action + " input");

      //querySelectorAll() behaves differently than most common JavaScript DOM libraries, which might lead to unexpected results.
      //Problem:while using forEach on inputs it iterated the nodelist in reverse order.
      //Converted Nodelist into array and then reversed it
      [...inputs].reverse().forEach(input => {
         //If input field in required and it does not satisfy the condition
         if(input.hasAttribute("required") && !regex.test(input.value))
         {
            //Focus on the input field and return the error
              input.focus();
              flag = true;
              error = `Incorrect input for ${beautifyKey(input.id)}`;
              return;
         }
      })
      return flag ?? error;
   }

   async function handleHoming(action)
   {
      if(action)
      {
         var response = await HomingService[action];
         const {data,error} = response;
         if(data)
         {

         }
         if(error)
         {

         }
      }
   }

   async function handleMixerJogging(action)
   {
      if(action)
      {
         var response = await MixerJoggingService[action];
         const {data,error} = response;
         if(data)
         {

         }
         if(error)
         {

         }
   }
   }

   async function handleCollectorJogging(action)
   {
      if(action)
      {
         var response = await CollectorJoggingService[action];
         const {data,error} = response;
         if(data)
         {

         }
         if(error)
         {

         }
      }
   }

   async function handleCollectorGoalPosition(action)
   {
      var error = validate(action);
     //console.log("Validation error",error);
      if(!error)
      {
         var response = await GoalPositionService[action];
         const {data,error} = response;
         if(data)
         {

         }
         if(error)
         {

         }
      }
      else 
      {
         errorNotification(error);
      }
   }

   async function moveCollector()
   {
      var axes = ["CollectorX","CollectorY","CollectorZ","CollectorA"];
      var check = () => {
                           var flag = false ;
                           for(var axis in axes)
                           {
                              if(!validate(axis))
                                 flag = true
                                 return;
                           }
                           return flag;
                        }
      if(check)
      {
        // console.log("Collector");
      }
      else
      {
         errorNotification("Provide data for at least one axis of Collector");
      }
   }

   async function handleMixerGoalPosition(action)
   {
          
   }

   async function handleControlService(action,params)
   {
      const payload = {restaurantId:props.machineID , ...params}
      const response = await ControlService[action](payload,props.kitchenId);
      const {data,error} = await response;
      if(data)
      {
        successNotification(`${action} task succesful`);
      }
      if(error)
      {
         if(error.message)
         {
           errorNotification(error.message);
         }
         else
         {
           errorNotification(`${action} task failed`);
         }
      }
   }

   useEffect(() =>{
    // id && props.setMachineID(id);   
   });

  return (
   <Page>
         <Container padding="0.5rem 0 0 0" widthBefore800="100%" width="30rem" jContent="space-evenly" >
            <Button active={page === 1 ? true : false} onClick={() => setPage(1)} margin="1rem 1rem 0 1rem" >Gantry System</Button>
            <Button active={page === 2 ? true : false} onClick={() => setPage(2)} margin="1rem 1rem 0 1rem" >Non Gantry System</Button>
         </Container>

      { 
         page === 1 && 
         <>
         <Container padding="0.5rem 0 0 0" widthBefore800="100%" width="30rem" jContent="space-evenly" >
            <Button active={tab === 1 ? true : false} onClick={() => showTab(1)} margin="1rem 1rem 0 1rem" >Jogging & Homing</Button>
            <Button active={tab === 2 ? true : false} onClick={() => showTab(2)} margin="1rem 1rem 0 1rem" >Goal Position</Button>
         </Container>

         {
            tab === 1 && 
            <Container widthAfter1000="62rem" width="100%" >
            <Card width="100%" padding="2rem 0" >
               <Header margin="" fontSize="1.6rem" >Homing</Header>
               <Container padding="1rem 0 0 0" paddingAt550="1rem" >
                  <Button margin="1rem">Collector Home X</Button>
                  <Button margin="1rem">Collector Home Y</Button>
                  <Button margin="1rem">Collector Home Z</Button>
                  <Button margin="1rem">Collector Home A</Button>
                  <Button margin="1rem">Mixer Home X</Button>
                  <Button margin="1rem">Mixer Home Y</Button>
                  <Button margin="1rem">Mixer Home A</Button>
               </Container>
            </Card>
            <Card width="100%" disabled={!homed} margin="2rem 0 0 0" padding="2rem 0" >
            <Header margin="" fontSize="1.6rem" >Mixer</Header>
                  <Container padding="0rem 0 0 0" paddingAt550="0rem 1rem" >
                        <Button margin="1rem">MX++</Button>
                        <Button margin="1rem">MX--</Button>
                        <Button margin="1rem">MY++</Button>
                        <Button margin="1rem">MY--</Button>
                        <Button margin="1rem">MA++</Button>
                        <Button margin="1rem">MA--</Button>
                     </Container>
            </Card>
            <Card width="100%" disabled={!homed} margin="2rem 0 0 0" padding="2rem 0" >
               <Header margin="" fontSize="1.6rem" >Collector</Header>
               <Container padding="1rem 0 0 0" paddingAt550="0rem 1rem" >
                  <Button margin="1rem">CX++</Button>
                  <Button margin="1rem">CX--</Button>
                  <Button margin="1rem">CY++</Button>
                  <Button margin="1rem">CY--</Button>
                  <Button margin="1rem">CZ++</Button>
                  <Button margin="1rem">CZ--</Button>
                  <Button margin="1rem">CA++</Button>
                  <Button margin="1rem">CA--</Button>
               </Container>
            </Card>
            </Container>
         }

         {
            tab === 2 && 
            <>
            <Container width="100%" jContent="space-evenly" padding="0" >
            {/*Collector Axes*/}

            <Card margin="2rem 1rem 0 1rem" padding="1.5rem 1rem" >
               <Header margin="" fontSize="1.6rem" >Collector X</Header>
               <Container id='CollectorX' flexDirection="column" paddingAt550="1rem 0rem" padding="1rem 1rem" jContent="space-between" >
                     <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                        <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">Target Value [mm]</Span>
                        <InputBox type="text" padding="0.5rem" width="100%" required id="Target-Value-Collector-X" />
                     </Div>
                     <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                        <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Speed [rpm]</Span>
                        <InputBox type="text" padding="0.5rem" width="100%" id="Target-Speed-Collector-X"  />
                     </Div>
                     <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                        <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Acc [ms]</Span>
                        <InputBox type="text" padding="0.5rem" width="100%"  id="Target-Acceleration-Collector-X" />
                     </Div>
               </Container>
               <Div jContent="flex-end" margin="0rem 0 0 0" > 
                     <Div margin="0.5rem">
                     <Button onClick={() => handleCollectorGoalPosition("CollectorX")} >Run</Button>
                     </Div>
                     <Div margin="0.5rem"  >
                     <Button >Stop</Button>
                     </Div>
               </Div>
            </Card>
            <Card margin="2rem 1rem 0 1rem"  padding="1.5rem 1rem" >
               <Header margin="" fontSize="1.6rem" >Collector Y</Header>
               <Container id='CollectorY' flexDirection="column" paddingAt550="1rem 0rem" padding="1rem 1rem" jContent="space-between" >
                     <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                        <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Value [mm]</Span>
                        <InputBox boxShadow="" padding="0.5rem" width="100%" required id="Target-Value-Collector-Y" />
                     </Div>
                     <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                        <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Speed [rpm]</Span>
                        <InputBox padding="0.5rem" width="100%" id="Target-Speed-Collector-Y" />
                     </Div>
                     <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                        <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Acc [ms]</Span>
                        <InputBox type="text" padding="0.5rem" width="100%" id="Target-Acceleration-Collector-Y" />
                     </Div>
               </Container>
               <Div jContent="flex-end" margin="0rem 0 0 0" > 
                     <Div margin="0.5rem">
                     <Button onClick={() => handleCollectorGoalPosition("CollectorY")} >Run</Button>
                     </Div>
                     <Div margin="0.5rem"  >
                     <Button >Stop</Button>
                     </Div>
               </Div>
            </Card>
            <Card margin="2rem 1rem 0 1rem"  padding="1.5rem 1rem" >
               <Header margin="" fontSize="1.6rem" >Collector Z</Header>
               <Container id='CollectorZ' flexDirection="column" paddingAt550="1rem 0rem" padding="1rem 1rem" jContent="space-between" >
                     <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                        <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Value [mm]</Span>
                        <InputBox boxShadow="" padding="0.5rem" width="100%" required id="Target-Value-Collector-Z" />
                     </Div>
                     <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                        <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Speed [rpm]</Span>
                        <InputBox padding="0.5rem" width="100%" id="Target-Speed-Collector-Z" />
                     </Div>
                     <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                        <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Acc [ms]</Span>
                        <InputBox type="text" padding="0.5rem" width="100%" id="Target-Acceleration-Collector-Z"  />
                     </Div>
               </Container>
               <Div jContent="flex-end" margin="0rem 0 0 0" > 
                     <Div margin="0.5rem">
                     <Button  onClick={() => handleCollectorGoalPosition("CollectorZ")} >Run</Button>
                     </Div>
                     <Div margin="0.5rem"  >
                     <Button >Stop</Button>
                     </Div>
               </Div>
            </Card>
            <Card margin="2rem 1rem 0 1rem"  padding="1.5rem 1rem" >
               <Header margin="" fontSize="1.6rem" >Collector A</Header>
               <Container id='CollectorA' flexDirection="column" paddingAt550="1rem 0rem" padding="1rem 1rem" jContent="space-between" >
                     <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                        <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Value [mm]</Span>
                        <InputBox boxShadow="" padding="0.5rem" width="100%" required id="Target-Value-Collector-A" />
                     </Div>
                     <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                        <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Speed [rpm]</Span>
                        <InputBox padding="0.5rem" width="100%" id="Target-Speed-Collector-A" />
                     </Div>
                     <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                        <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Acc [ms]</Span>
                        <InputBox type="text" padding="0.5rem" width="100%" id="Target-Acceleration-Collector-A" />
                     </Div>
               </Container>
               <Div jContent="flex-end" margin="0rem 0 0 0" > 
                     <Div margin="0.5rem">
                     <Button  onClick={() => handleCollectorGoalPosition("CollectorA")} >Run</Button>
                     </Div>
                     <Div margin="0.5rem"  >
                     <Button >Stop</Button>
                     </Div>
               </Div>
            </Card>
            
            </Container>

            <Div jContent="center" margin="3rem 0 0 0" > 
                     <Div margin="0.5rem">
                     <Button onClick={() => moveCollector()} >Move Collector</Button>
                     </Div>
                     <Div margin="0.5rem"  >
                     <Button >Move Mixer</Button>
                     </Div>
               </Div>

            <Container padding="1rem 0 0 0" widthAfter1000="80%" jContent="space-evenly" >
                  <Card margin="2rem 1rem 0 1rem"  padding="1.5rem 1rem" >
                     <Header margin="" fontSize="1.6rem" >Mixer X</Header>
                     <Container flexDirection="column" paddingAt550="1rem 0rem" padding="1rem 1rem" jContent="space-between" >
                           <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                              <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Value [mm]</Span>
                              <InputBox boxShadow="" padding="0.5rem" width="100%" />
                           </Div>
                           <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                              <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Speed [rpm]</Span>
                              <InputBox padding="0.5rem" width="100%" />
                           </Div>
                           <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                              <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Acc [ms]</Span>
                              <InputBox type="text" padding="0.5rem" width="100%"   />
                           </Div>
                     </Container>
                  </Card>
                  <Card margin="2rem 1rem 0 1rem"  padding="1.5rem 1rem" >
                     <Header margin="" fontSize="1.6rem" >Mixer Y</Header>
                     <Container flexDirection="column" paddingAt550="1rem 0rem" padding="1rem 1rem" jContent="space-between" >
                           <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                              <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Value [mm]</Span>
                              <InputBox boxShadow="" padding="0.5rem" width="100%" />
                           </Div>
                           <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                              <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Speed [rpm]</Span>
                              <InputBox padding="0.5rem" width="100%" />
                           </Div>
                           <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                              <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Acc [ms]</Span>
                              <InputBox type="text" padding="0.5rem" width="100%"   />
                           </Div>
                     </Container>
                  </Card>
                  <Card margin="2rem 1rem 0 1rem"  padding="1.5rem 1rem" >
                     <Header margin="" fontSize="1.6rem" >Mixer A</Header>
                     <Container flexDirection="column" paddingAt550="1rem 0rem" padding="1rem 1rem" jContent="space-between" >
                           <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                              <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Value [mm]</Span>
                              <InputBox boxShadow="" padding="0.5rem" width="100%" />
                           </Div>
                           <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                              <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Speed [rpm]</Span>
                              <InputBox padding="0.5rem" width="100%" />
                           </Div>
                           <Div margin="1rem 1rem 0 1rem" flexDirection="column" >
                              <Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600" >Target Acc [ms]</Span>
                              <InputBox type="text" padding="0.5rem" width="100%"   />
                           </Div>
                     </Container>
                  </Card>
            </Container>
      </>
   }
         </>
      }
      {
         page === 2 && 
         <Div flexDirection="column" width="100%" alignItem="center" >
         <Card padding="1rem" jContent="center" width="90%" widthAfter1000="max-content" margin="2rem 0 0 0" flexDirection="column" >
            <Div jContent="center" alignItem="center" fontSize="1.4rem" >DI Actions</Div>
            <Div flexWrap="wrap" flexDirection="row" jContent={"center"} margin="1rem 0 0 0" >
                <Div margin="0.5rem" onClick={() =>{handleControlService("Move Pusher Forward")}} >
                <Button>Move Pusher Forward</Button>
                </Div>
                <Div margin="0.5rem" onClick={() =>{handleControlService("Move Pusher Backward")}} >
                <Button>Move Pusher Backward</Button>
                </Div>
                <Div margin="0.5rem" onClick={() =>{handleControlService("Move Shutter Upwards")}} >
                <Button>Move Shutter Upwards</Button>
                </Div>
                <Div margin="0.5rem" onClick={() =>{handleControlService("Move Shutter Downwards")}} >
                <Button>Move Shutter Downwards</Button>
                </Div>
            </Div>
          </Card>
          <Card flexWrap="wrap" padding="1rem" jContent="center" width="90%" widthAfter1000="max-content" margin="2rem 0 0 0" flexDirection="row" >
               <Div margin="0.5rem" onClick={() =>{handleControlService("Move Cleaning Unit Up")}} >
                <Button>Move Cleaning Unit Up</Button>
                </Div>
                <Div margin="0.5rem" onClick={() =>{handleControlService("Move Cleaning Unit Down")}} >
                <Button>Move Cleaning Unit Down</Button>
                </Div>
          </Card>
          <Card flexWrap="wrap" padding="1rem" jContent="center" width="90%" widthAfter1000="max-content" margin="2rem 0 0 0" flexDirection="row" >
               <Div margin="0.5rem" onClick={() =>{showModal(true)}} >
                <Button>Rotate Mixer</Button>
                </Div>
                <Div margin="0.5rem" onClick={() =>{handleControlService("Stop Mixer Rotation")}} >
                <Button>Stop Mixer Rotation</Button>
                </Div>
          </Card>
         </Div>
      }

      <CSSTransition timeout={300} in={modal} unmountOnExit classNames={"module"} >
           <Background>
             <Modal>
             <Div color='#fff' background="rgba(45, 35, 66, 0.8)" padding="1rem" jContent="space-between">
             <Span fontSize="1.4rem" >Rotate Mixer</Span>
             <img style={{'height':'1.5rem','filter':'invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)'}} src={close} alt="close" onClick={() => {showModal(false)}}  />
             </Div>
             <Div flexDirection="column" padding="0" width="100%" alignItem="center" flexWrap="wrap" >
            <Div width="100%" flexDirection="column" padding="1rem 1.5rem"  >
                  <Span color="rgba(0,0,0,0.6)" >RPM</Span>
                  <InputBox onChange={e => setMixerPayload({...mixerPayload,rpm:e.target.valueAsNumber})} type="number" id={""} width="100%" margin="0.5rem 0 0 0" padding="0.5rem" />
            </Div>
            <Div width="100%" flexDirection="column" padding="1rem 1.5rem"  >
                  <Span color="rgba(0,0,0,0.6)" >Direction</Span>
                  <Dropdown optionsList={rotateDirect} value={mixerPayload.direction} onChange={value => setMixerPayload({...mixerPayload,direction:value})} head="-" widthVal="100%" margin="0.5rem 0 0 0" boxShadow="" headerFontSize="1rem" border="1px solid rgba(0,0,0,0.4)" />
               </Div>
            </Div>
             <Div padding="0 1rem 1rem 1rem" jContent="flex-end" margin="1rem 0 0 0" > 
                <Div margin="0.5rem"  onClick={() => {showModal(false)}} >
                <Button>Cancel</Button>
                </Div>
                <Div margin="0.5rem"  >
                <SuccessButton onClick={() => handleControlService("Rotate Mixer",{taskData:{...mixerPayload}})} >Confirm</SuccessButton>
                </Div>
             </Div>
             </Modal>
           </Background>
      </CSSTransition>

    </Page>
  )
}

export default ManualControlConnector(ManualControl);

/* 

*/